import { Buffer } from "buffer";
import { useMemo, type FC } from "react";
import { useSubscription } from "react-relay";
import type { GraphQLTaggedNode } from "relay-runtime";

type Props = {
  address?: string | null;
  connection?: string | null;
  subscription: GraphQLTaggedNode;
};

/** A partially loaded pair has no Relay connection to prepend to yet. Mount
 * the hook only once the connection exists; unmount disposes the subscription.
 * Keeping this boundary separate also avoids conditional hooks in Trade.
 */
export const TradeHistorySubscription: FC<Props> = (props) =>
  props.address && props.connection ? (
    <ConnectedHistory
      {...props}
      address={props.address}
      connection={props.connection}
    />
  ) : null;

const ConnectedHistory: FC<Props & { address: string; connection: string }> = ({
  address,
  connection,
  subscription,
}) => {
  const config = useMemo(
    () => ({
      subscription,
      variables: {
        connection,
        prefix: Buffer.from(`FinTrade:${address}`).toString("base64"),
      },
    }),
    [address, connection, subscription]
  );
  useSubscription(config);
  return null;
};
